import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ title, posted, category, image, isNew = false, id }) => {
  const fallbackImage = "https://via.placeholder.com/250x120?text=No+Image";
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/blog/${id}`);
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        width: 240,
        height: 280,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.03)",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          height="120"
          image={image || fallbackImage}
          alt={title}
        />
        {isNew && (
          <Chip
            label="Latest"
            color="primary"
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1,
            }}
          />
        )}
      </Box>

      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          <Typography variant="body1" component="div" gutterBottom>
            {title}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {category}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {new Date(posted).toLocaleDateString()}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BlogCard;
